import { useSelector } from 'react-redux';
import {
  archivedEventsSelector,
  sortByReleaseAtEventsSelector,
} from '@/store/selectors/domain/archivedEvents';

export const useArchivedEvents = () => {
  const archivedEvents = useSelector(archivedEventsSelector);
  const groupedArchivedEventData = useSelector(sortByReleaseAtEventsSelector);

  return {
    archivedEvents: archivedEvents?.listEvent,
    groupedArchivedEventData,
  };
};
